// extracted by mini-css-extract-plugin
export var errorsContainer = "_up-1";
export var link = "_up-0";